<template>
    <div class="wrapper">
        <div
            v-for="({address_id, address, city_name, consignee, district_name, mobile, province_name}, index) in addressList"
            :key="address_id"
            :class="{chosen: currAddressId === address_id}"
           
            @click="chosemr(address_id)"
        >
            <span>收货人: {{consignee}}</span>
            <span>{{mobile}}</span>
            <span>
                {{`${province_name} ${city_name} ${district_name} ${address}`}}
            </span>
            <address-dialog
                :editData="addressList[index]"
                :getAddress="getAddress"
                :type="1"
            >
                <span class="edit">[ 编辑 ]</span>
            </address-dialog>
            <el-popover
                :ref="address_id"
                placement="bottom-start"
                width="100"
                :value="delVisible === address_id"
            >
                <p style="text-align: center">确定删除吗？</p>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="delVisible=''">取消</el-button>
                    <el-button
                        :loading="btnLoading"
                        v-on:click="deleteAddr(address_id)"
                        type="primary"
                        size="mini">确定
                    </el-button>
                </div>
                <span slot="reference" @click.stop="delVisible=address_id">[ 删除 ]</span>
            </el-popover>
            <img src="../../assets/supply/chosen.svg" alt=""/>
        </div>
        <div class="add">
            <address-dialog
                :className="'dialog'"
                :getAddress="getAddress"
                :type="2"
            >
                <div>
                    <i class="el-icon-circle-plus-outline"></i>添加新地址
                </div>
            </address-dialog>
        </div>
        <!--占位-->
        <div style="border: 0; cursor: inherit; background: transparent" v-if=" addressList.length%3 === 1"></div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import { createNamespacedHelpers } from 'vuex';
    import { getAddressSelect, getAddress, delAddress, getUserInfo } from '../../stores/api';
    import AddressDialog from '../Common/AddressDialog.vue';

    Vue.component('address-dialog', AddressDialog);
    const {mapMutations} = createNamespacedHelpers('supplyChainStore');

    export default {
        data () {
            return {
                currAddressId: '',    //当前选中地址ID
                addressList: [],      //收货地址列表
                provinceList: [],     //省份，请求一次
                btnLoading: false,    //所有popover的确认按钮
                delVisible: '',       //记录点击id,展示对应的dialog
                address_id:'',
            };
        },
        beforeMount () {
            this.getAddress();
//            this.getProvinces();
        },
        methods: {
            getProvinces () {
                getAddressSelect().then(res => {
                    this.provinceList = res.data;
                });
            },
            getAddress () {
                return getAddress().then(res => {
                    console.log(res)
                    const {consignee_list} = res.data;
                    //初始化默认选中
                    if (this.currAddressId === '') {
                        this.currAddressId = consignee_list[0].address_id;
                    }
                    this.currAddressId = localStorage.getItem('address_id')
                    this.addressList = consignee_list;
                });
            },
            deleteAddr (id) {
                this.btnLoading = true;
                delAddress(id).then(async () => {
                    await this.getAddress();
                    this.$notify.success({
                        title: '操作成功',
                        message: '删除地址成功',
                    });
                }).catch((err) => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.delVisible = '';
                    this.btnLoading = false;
                });
            },
            getUserInfo(){
                // getUserInfo().then(res=>{
                //     console.log(res)
                //     this.address_id = res.data.userinfo.address_id
                // })
            },
            //选择默认id
            chosemr(address_id){
                this.currAddressId = address_id;
                localStorage.setItem('address_id',address_id)

            },
            ...mapMutations(['setOrderForm']),
        },
        watch: {
            currAddressId (val) {
                this.setOrderForm({address_id: val});
            }
        },
        mounted(){
            this.getUserInfo();
        }
    };
</script>

<style lang="less" scoped>
    @import "../../default";

    .wrapper {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        & > div {
            width: 420px;
            height: 120px;
            margin-bottom: 10px;
            position: relative;
            background: #fff;
            padding: 32px 24px;
            border: 1px solid #c7ccd4;
            cursor: pointer;
            &:hover {
                border-color: @orange;
            }
            & > span:nth-child(2) {
                margin-left: 24px;
            }
            & > span:nth-child(3) {
                display: block;
                margin: 15px 0;
            }
            /*& > span:nth-child(4) {*/
            /*font-size: 14px;*/
            /*color: rgba(39, 149, 245, 0.7);*/
            /*cursor: pointer;*/
            /*&:hover {*/
            /*color: #2795f5;*/
            /*}*/
            /*}*/
            .edit {
                font-size: 14px;
                color: rgba(39, 149, 245, 0.7);
                cursor: pointer;
                &:hover {
                    color: #2795f5;
                }
            }
            & > span:nth-child(5) {
                font-size: 14px;
                color: rgba(156, 162, 173, 0.7);
                cursor: pointer;
                margin-left: 8px;
                &:hover {
                    color: #9ca2ad;
                }
            }
            & > img {
                width: 48px;
                height: 48px;
                position: absolute;
                right: 0;
                bottom: 0;
                display: none;
            }
        }
        .chosen {
            border-color: @orange;
            & > img {
                display: inherit;
            }
        }
        .add {
            width: 468px;
            height: 185px;
            padding: 0;
            border-style: dashed;
            font-size: 24px;
            color: #c7ccd4;
            & > i {
                margin-right: 5px;
            }
            span > div {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .dialog {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/SupplyCh/Address.vue